export default "__VITE_ASSET__3de418eb__"